import React from "react"
import { observer } from "mobx-react-lite"
import { useStores } from "~models"
import { MessageModalProps } from "./types"
import styled from "~/ui/styled"
import { ColumnFlex, CenterFlex, Text, BetweenFlex, Button } from "~components/El"
import { Mask } from "~widgets/mask"

const Popup = styled.Modal``

const Container = styled.View`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`

// 全局通用文字消息提示弹窗
const MessageModalContent: React.FC<any> = (props) => {
  const { closeModal, extra = {} } = props
  const {
    onConfirm,
    onCancel,
    title = "温馨提示",
    confirmText = "确认",
    cancelText = "取消",
    text = "",
    message = "",
    danger_text = "",
    Custom = null,
    messageContentStyle = {},
    style = {},
  } = extra
  const hasTitle = Boolean(title)
  return (
    <ColumnFlex bg="blockBackground" width="90%" borderRadius="12px" style={{ ...style }}>
      {hasTitle && (
        <CenterFlex height="56px" width="100%">
          <Text color="text" fontSize="18px" fontWeight="600">
            {title}
          </Text>
        </CenterFlex>
      )}
      {Custom || (
        <ColumnFlex
          width="100%"
          padding="5px 15px 15px"
          gap="10px"
          style={{ ...messageContentStyle }}
        >
          <CenterFlex flexDirection="column" width="100%">
            <Text color="text" fontSize="14px" textAlign="center" lineHeight="20px">
              {text}
            </Text>
            <Text color="text" fontSize="14px" textAlign="center" lineHeight="20px">
              {message}
            </Text>
            <Text color="danger" fontSize="14px" textAlign="center" lineHeight="20px">
              {danger_text}
            </Text>
          </CenterFlex>
        </ColumnFlex>
      )}
      {(onConfirm || onCancel) && (
        <BetweenFlex gap="10px" width="100%" padding="5px 15px 15px">
          {onCancel && (
            <Button
              flex={1}
              bg="background"
              borderRadius="10px"
              height="40px"
              onClick={() => {
                closeModal()
                onCancel("cancel")
              }}
            >
              <Text color="secondaryText">{cancelText}</Text>
            </Button>
          )}
          {onConfirm && (
            <Button
              flex={1}
              bg="buttonBackground"
              borderRadius="10px"
              height="40px"
              onClick={() => {
                closeModal()
                onConfirm("confirm")
              }}
            >
              <Text color="#fff" fontWeight="600">
                {confirmText}
              </Text>
            </Button>
          )}
        </BetweenFlex>
      )}
    </ColumnFlex>
  )
}

const MessageModal: React.FC<MessageModalProps> = () => {
  const { globalModalStore } = useStores()
  const { messageModal, setMessageModal } = globalModalStore
  const { visible, extra } = messageModal
  const { maskClosable } = extra
  const closeModal = () => {
    setMessageModal({
      visible: false,
      extra: {},
    })
  }
  return (
    <Popup visible={visible} animationType="fade" transparent={true}>
      <Container>
        <Mask
          onClick={() => {
            maskClosable && closeModal()
          }}
        />
        <CenterFlex width="100%" style={{ position: "relative", zIndex: 1 }}>
          <MessageModalContent closeModal={closeModal} extra={extra} />
        </CenterFlex>
      </Container>
    </Popup>
  )
}

export default observer(MessageModal)
